/**
 * Cookie utility functions for Vue.js SSO handling
 * Replaces functionality from auth.aspx
 */

export const cookieUtils = {
	/**
	 * Set a cookie with Base64 encoded value
	 * @param {string} name - Cookie name
	 * @param {string} value - Cookie value
	 * @param {number} days - Expiration in days (optional)
	 */
	setEncodedCookie(name, value, days = 7) {
		const encodedValue = btoa(unescape(encodeURIComponent(value)));
		let expires = '';

		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = `; expires=${date.toUTCString()}`;
		}

		document.cookie = `${name}=${encodedValue}${expires}; path=/`;
	},

	/**
	 * Get and decode a cookie value
	 * @param {string} name - Cookie name
	 * @returns {string} - Decoded cookie value
	 */
	getDecodedCookie(name) {
		const nameEQ = `${name}=`;
		const cookies = document.cookie.split(';');

		for (let cookie of cookies) {
			let c = cookie.trim();
			if (c.indexOf(nameEQ) === 0) {
				const encodedValue = c.substring(nameEQ.length);
				try {
					return decodeURIComponent(escape(atob(encodedValue)));
				} catch (e) {
					console.warn(`Failed to decode cookie ${name}:`, e);
					return '';
				}
			}
		}
		return '';
	},

	/**
	 * Delete a cookie
	 * @param {string} name - Cookie name
	 */
	deleteCookie(name) {
		document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
	},

	/**
	 * Set all SSO cookies (equivalent to auth.aspx functionality)
	 * @param {Object} ssoParams - SSO parameters
	 */
	setSSOCookies(ssoParams) {
		const {
			u = '', // user
			i = '', // identifier
			action = '', // action
			origin = '', // origin
			d = '', // delegation
			r = '', // redirect
			m = '', // module
			rp = '', // reset password
			sso = '', // sso customer
		} = ssoParams;

		// Set login authenticated flag
		this.setEncodedCookie('__la', '1');

		// Set user and identifier
		this.setEncodedCookie('__u', u);
		this.setEncodedCookie('__i', i);

		// Set application (equivalent to ECOS in auth.aspx)
		this.setEncodedCookie('__a', 'ECOS');

		// Set action and origin
		this.setEncodedCookie('__action', action);
		this.setEncodedCookie('__origin', origin);

		// Optional parameters
		if (d) this.setEncodedCookie('__d', d);
		if (r) this.setEncodedCookie('__r', r);
		if (m) this.setEncodedCookie('__m', m);
		if (rp) this.setEncodedCookie('__rp', rp);
		if (sso) this.setEncodedCookie('__sso', sso);
	},
};
